import { render, staticRenderFns } from "./ClientAccessibility.vue?vue&type=template&id=27600c43&scoped=true&"
import script from "./ClientAccessibility.vue?vue&type=script&lang=js&"
export * from "./ClientAccessibility.vue?vue&type=script&lang=js&"
import style0 from "./ClientAccessibility.vue?vue&type=style&index=0&id=27600c43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27600c43",
  null
  
)

export default component.exports